import "./cart.css";

import CartCom from "../../../Components/CartCom";
import { InstructionsContextProvider } from "../../../APIContext/InstructionsContext";
import { NewUserContextProvider } from "../../../APIContext/NewUserContext";

const Cart = () => {
  return (
    <NewUserContextProvider>
      <InstructionsContextProvider>
        <CartCom />
      </InstructionsContextProvider>
    </NewUserContextProvider>
  );
};

export default Cart;
